import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=10fba929&scoped=true&lang=html&"
import script from "./Values.vue?vue&type=script&lang=js&"
export * from "./Values.vue?vue&type=script&lang=js&"
import style0 from "./Values.vue?vue&type=style&index=0&id=10fba929&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fba929",
  null
  
)

export default component.exports